import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cca9f2fa")

_pushScopeId("data-v-cca9f2fa")
const _hoisted_1 = {
  class: "entrust_main",
  id: "entrust"
}
const _hoisted_2 = { class: "entrust_body" }
const _hoisted_3 = { class: "comTitle_main" }
const _hoisted_4 = { class: "comTitle_left" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Пункты проверки ")
const _hoisted_6 = { class: "allOk" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "xctxt" }, "Показать только дефекты", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "van-switch__node" }, null, -1)
const _hoisted_9 = { class: "entrust-main" }
const _hoisted_10 = { class: "entrust-img" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      class: "weituoBg",
      src: require("../../../../../assets/promiseFrame/weituoBg.png")
    }, null, 8, ["src"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createVNode("div", _hoisted_6, "Дефектов не обнаружено", 512), [
            [_vShow, !_ctx.state.hasWarn]
          ])
        ]),
        _withDirectives(_createVNode("div", {
          class: "switch",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeShowFlaw && _ctx.changeShowFlaw(...args)))
        }, [
          _hoisted_7,
          _createVNode("div", {
            role: "switch",
            class: ["van-switch", {'van-switch--on': _ctx.state.onlyFlaw}]
          }, [
            _hoisted_8
          ], 2)
        ], 512), [
          [_vShow, _ctx.state.hasWarn]
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.entrustList, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "entrust-main-item",
            key: item.code,
            onClick: ($event: any) => (_ctx.clickTab(item.code))
          }, [
            _createVNode("div", _hoisted_10, [
              _createVNode("img", {
                src: item.additionUrl,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _createVNode("p", null, _toDisplayString(item.name), 1)
          ], 8, ["onClick"]))
        }), 128))
      ])
    ])
  ]))
})